import React, { Component } from 'react';
import { withFirebase } from '../../shared/firebase';
import { Loading, ErrorMessage } from '../../shared/layout';

import { getRouteParam, upgradeMdl } from '../../utils';
import './PollToken.css';

class PollTokensBase extends Component {

  state = {
    poll: null,
    validTokens: [],
    invalidTokens: [],
    loading: true,
    tokenMode: false,
  }

  toggleTokenMode = () => this.setState({ tokenMode: !this.state.tokenMode })

  getPollId = () => getRouteParam(this.props, 'pollId');

  watchTokens = () => {
    const pollId = this.getPollId();

    this.props.firebase.getPollTokens(pollId)
      .then(tokens => {
        this.setState({
          validTokens: tokens.filter(token => token.valid),
          invalidTokens: tokens.filter(token => !token.valid),
          loading: false
        }, upgradeMdl);
      })
      .catch(err => {
        console.error(err);
        this.setState({
          error: 'GENERIC_ERROR',
          loading: false
        });
      });
  }

  componentDidMount() {
    const pollId = this.getPollId();

    this.props.firebase.getPoll(pollId)
      .then(poll => this.setState({ poll }))
      .then(() => this.watchTokens())
      .catch(err => {
        console.error(err);
        this.setState({
          error: 'GENERIC_ERROR',
          loading: false
        });
      });
  };

  render() {
    const { validTokens, invalidTokens, loading, poll, error, tokenMode } = this.state;
    const baseUrl = `${window.location.origin}/vote`;

    return loading ? <div className="loading-page-content"><Loading /></div> :
      error ? <div className="error-page-content"><ErrorMessage message={error} /></div> : (
      <div className="mdl-grid">
        <div className="mdl-card mdl-shadow--2dp mdl-cell mdl-cell--12-col mdl-cell--12-col-tablet mdl-cell--12-col-desktop">
          <div className="mdl-card__title mdl-color--primary mdl-color-text--white" style={{flexDirection: 'column'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
              <h2 className="mdl-card__title-text">{tokenMode ? 'Tokens' : 'Links'}: {poll && poll.name}</h2>

              <label className="mdl-switch mdl-js-switch mdl-js-ripple-effect token-switch" htmlFor="tokens-type" style={{width: '160px'}}>
                <input
                  type="checkbox"
                  id="tokens-type"
                  className="mdl-switch__input"
                  value={tokenMode}
                  onChange={this.toggleTokenMode}
                ></input>
                <span className="mdl-switch__label">{!tokenMode ? 'Tokens' : 'Links'}</span>
              </label>
            </div>
            <div className="app-divider"></div>
            <p>Below we provide you with tokens for poll you have just published. Tokens can be used only once. Please keep them secure and share only with people that are allowed to vote. We recommend you to share them in private communication one by one. You can also use voting links, that points directly to poll voting page.</p>
          </div>
          <div className="mdl-card__supporting-text mdl-color-text--grey-600" style={{width: 'initial'}}>
            <h3>Unused {tokenMode ? 'Tokens' : 'Links'}: {validTokens.length}</h3>
            <div>
              {
                validTokens.map(token => (
                  <div key={token.id} style={{marginBottom: '4px'}}>
                    {tokenMode ? `${this.getPollId()}_${token.id}` : `${baseUrl}/${this.getPollId()}_${token.id}`}
                  </div>
                ))
              }
            </div>

            <div className="app-divider-bold"></div>

            <h3>Used {tokenMode ? 'Tokens' : 'Links'}: {invalidTokens.length}</h3>
            <div>
              {
                invalidTokens.map(token => (
                  <div key={token.id} style={{marginBottom: '4px'}}>
                    {tokenMode ? `${this.getPollId()}_${token.id}` : `${baseUrl}/${this.getPollId()}_${token.id}`}
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export const PollTokens = withFirebase(PollTokensBase);
